import React from "react";
import "../../styles/hero.css";
import hero from "../../assets/Heros-04-1.png";
import { useNavigate } from "react-router-dom";


const Hero = () => {
   const navigate = useNavigate();
  return (
    <section className="pro-hero-wrapper container">
      <div className="pro-hero-card row align-items-center g-0">
        {/* LEFT TEXT SECTION */}
        <div className="col-lg-7 col-md-12 pro-hero-text-col position-relative">
          <h1 className="pro-hero-title">
            Upgrade Your Skills.
            <br />
            Unlock Your Potential.
          </h1>

          <p className="pro-hero-subtitle">
            At Madhi Academy, we provide practical, career-oriented skill
            training designed to make you job-ready. Our courses are crafted for
            students, job seekers, and working professionals who want to boost
            their careers with ERP expertise, computer literacy, and fluent
            English communication.
          </p>

          <div className="pro-hero-btn-wrapper">
            <button
              className="pro-btn-enroll"
              onClick={() => navigate("/contact")}
            >
             Start Learning Today
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="col-lg-5 col-md-12 pro-hero-img-col">
          {/* 2. Main Professional Image (Front) */}
          <img
            src={hero}
            alt="Skills Training Professional"
            className="pro-hero-main-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
